/**
 * **NOTE** The styles in this file are a direct copy of the styles found at:
 * `src/modules/templateEditor/EditPush/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import styled from 'styled-components';
import { colors, fonts, fontWeights, letterSpacing, spacing, subtleShadow } from 'ui/theme';

const notificationBackground = `radial-gradient(circle, transparent, rgba(252, 172, 209, 0.2) 100%), radial-gradient(circle, transparent, rgba(181, 109, 198, 0.3) 100%)`;

export const PushPreviewContainer = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const DeviceContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 474px;
  margin: auto;
  overflow: hidden;
  width: 286px;
  letter-spacing: ${letterSpacing.pos10};
  border-radius: 20px;
  background-color: ${colors.purple10};
  background-image: ${notificationBackground};
  ${subtleShadow}
  &[data-device='android'] {
    align-items: center;
    font-family: ${fonts.roboto};
  }
  &[data-device='apple'] {
    font-family: ${fonts.sfPro};
  }
`;
export const NotificationBubbleIos = styled.div`
  background-color: ${colors.white};
  border-radius: 9px;
  box-sizing: border-box;
  display: flex;
  margin-top: 16px;
  padding: 8px 11px 7px 6px;
  width: 278px;;
`;

export const NotificationBubbleAndroid = styled.div`
  background-color: ${colors.white};
  border-radius: 2px;
  box-sizing: border-box;
  color: ${colors.black};
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  padding: 20px 20px 20px 20px;
  width: 280px;
`;

export const ExpandedNotificationBubbleAndroid = styled(NotificationBubbleAndroid)`
  margin-top: 0;
  padding: 0;
`;

export const ExpandedNotificationBubbleAndroidHeaderAndBodyWrapper = styled.div`
  padding: 12px 10px 13px 10px;
  z-index: 1;
`;

export const ExpandedNotificationBubbleIos = styled.div`
  background-color: ${colors.white};
  border-radius: 9px;
  box-sizing: border-box;
  flex-direction: row;
  overflow: hidden;
`;

export const ExpandedNotificationAndroidWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

export const NotificationBubbleWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

export const ExpandedNotificationBubbleWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  width: 278px;
  z-index: 1;
`;

export const NotificationAttachmentIos = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
`;

export const ExpandedNotificationAttachmentIos = styled.img`
  max-width: 100%;
  max-height: fit-content;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
`;

export const NotificationAttachmentAndroid = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

export const ExpandedNotificationAttachmentAndroid = styled.img`
  max-width: 100%;
  max-height: fit-content;
`;

export const ExpandedNotificationAttachmentWrapperIos = styled.div`
  max-height: 161px;
  max-width: 306px;
  min-width: 278px;
  overflow: hidden;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
`;

export const ExpandedNotificationAttachmentWrapperAndroid = styled(
  ExpandedNotificationAttachmentWrapperIos,
)`
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
`;

export const NotificationAttachmentWrapper = styled.div`
  height: 28px;
  width: 28px;
`;

export const NotificationContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NotificationPlaceholder = styled.div`
  align-items: center;
  display: flex;
`;

export const ExpandedNotificationPlaceholder = styled(NotificationPlaceholder)`
   flex: 0;
   padding: 8px 11px 7px 6px;
`;

export const NotificationBubbleAndroidHeaderTime = styled.div`
  align-items: center;
  display: flex;
  font-size: 10px;
  justify-content: flex-start;
  gap: 10px;
  width: 225px;
`;

export const NotificationBubbleAndroidBody = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 9px;
  width: 240px;
`;

export const NotificationBubbleAndroidBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
`;

export const NotificationBubbleAndroidBodyContentMsgTitle = styled.div`
  font-size: 14px;
  font-weight: ${fontWeights.medium};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const NotificationBubbleAndroidBodyContentMsg = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 5px;
`;

export const NotificationBubbleAndroidBodyContentMsgTxt = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;

export const NotificationBubbleIosContent = styled.div`
  flex: 0 0 auto;
  padding-left: ${spacing.half};
  width: 230px;
`;

export const ExpandedNotificationBubbleIosContent = styled.div`
  padding-top: 13px;
  padding-bottom: 13px;
`;

export const NotificationBubbleIosContentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  width: inherit;
`;

export const ExpandedNotificationBubbleIosHeaderAndBodyWrapper = styled.div`
  flex-direction: column;
  display: flex;
  width: 190px;
`;

export const ExpandedNotificationBubbleIosContentHeader = styled.div`
  display: flex;
`;

export const NotificationBubbleIosContentHeaderSender = styled.div`
  color: ${colors.textPrimary};
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: ${fontWeights.semiBold};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ExpandedNotificationBubbleIosContentHeaderSender = styled(
  NotificationBubbleIosContentHeaderSender,
)`
  flex: none;
`;

export const NotificationBubbleIosContentBody = styled.div`
  display: flex;
  align-items: flex-start;
  width: 190px;
`;

export const NotificationBubbleIosContentBodyMsg = styled.div`
  color: ${colors.textPrimary};
  flex: 1 1 auto;
  font-size: 12px;
  line-height: 1.3;
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;
